import { Component, Input } from "@angular/core";
import { Administre } from "../../../interfaces/Administre";

@Component({
  selector: "app-banque",
  templateUrl: "./banque.component.html",
  standalone: false,
})
export class BanqueComponent {
  @Input() administre: Administre;
}
